import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Componentes compartidos
import { ImageZoomComponent } from './components/image-zoom/image-zoom.component';
import { AdvancedSearchComponent } from './components/advanced-search/advanced-search.component';
import { SidebarFiltersComponent } from './components/sidebar-filters/sidebar-filters.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RateLimitToastComponent } from './components/rate-limit-toast/rate-limit-toast.component';
import { RateLimitOverlayComponent } from './components/rate-limit-overlay/rate-limit-overlay.component';

@NgModule({
  declarations: [
    ImageZoomComponent,
    AdvancedSearchComponent,
    SidebarFiltersComponent,
    NotFoundComponent,
    RateLimitToastComponent,
    RateLimitOverlayComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  exports: [
    // Componentes
    ImageZoomComponent,
    AdvancedSearchComponent,
    SidebarFiltersComponent,
    NotFoundComponent,
    RateLimitToastComponent,
    RateLimitOverlayComponent,

    // Módulos comunes
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ]
})
export class SharedModule { }